import { FC } from 'react'
import { connect, ConnectedComponent } from 'react-redux'
import { getFormValues } from 'redux-form'

import { DELIVERY_OPTION } from '@cinch/oxd-containers/delivery-preference/src'
import { defaultValues, FORM_NAME } from '@cinch/oxd-containers/dealer-listing-filters/src'
import { getDelivery } from '@cinch/oxd-redux/profile/src/selectors'

import MobileFilters, { MobileFilterProps } from '../components/mobile-filters/mobile-filters.component'

export const mapStateToProps = (state: any) => {
  const values: { [key: string]: any } = getFormValues(FORM_NAME)(state)
  const changedValues = values
    ? Object.keys(defaultValues).filter((key) => values[key] !== defaultValues[key as keyof typeof defaultValues])
    : []
  const locationOptions = ['longitude', 'latitude']
  const nonLocationChangedVals = changedValues.filter((value) => !locationOptions.includes(value))
  const hasLocation = changedValues.length !== nonLocationChangedVals.length
  const hasDelivery = getDelivery(state) === DELIVERY_OPTION.DELIVERY

  const numSelectedFilters =
    hasLocation || hasDelivery ? nonLocationChangedVals.length + 1 : nonLocationChangedVals.length

  return { numSelectedFilters }
}

const MobileFiltersContainer: ConnectedComponent<
  FC<MobileFilterProps>,
  Partial<MobileFilterProps> & { children?: React.ReactNode | React.ReactNodeArray }
> = connect(mapStateToProps)(MobileFilters)

export default MobileFiltersContainer
